<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jsACnv/tc-custom/9780062231437.jpg?1720831269607" alt="This image is the cover for the book Dirty Version"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dirty Version
      </h1>
      <p class="bookDescription body article font2">
        <p>On the tenth anniversary of his death, <i>The Dirty Version</i> is the first biography of hip hop superstar and founding member of the Wu-Tang Clan, Ol’ Dirty Bastard, to be written by someone from his inner circle: his right-hand man and best friend, Buddha Monk.</p><p>Ol’ Dirty Bastard rocketed to fame with the Wu-Tang Clan, the raucous and renegade group that altered the world of hip hop forever. ODB was one of the Clan’s wildest icons and most inventive performers, and when he died of an overdose in 2004 at the age of thirty-five, millions of fans mourned the loss. ODB lives on in epic proportions and his antics are legend: he once picked up his welfare check in a limousine; lifted a burning car off a four-year-old girl in Brooklyn; stole a fifty-dollar pair of sneakers on tour at the peak of his success. Many have questioned whether his stunts were carefully calculated or the result of paranoia and mental instability.</p><p>Now, Dirty’s friend since childhood, Buddha Monk, a Wu-Tang collaborator on stage and in the studio, reveals the truth about the complex and talented performer. From their days together on the streets of Brooklyn to the meteoric rise of Wu-Tang’s star, from bouts in prison to court-mandated rehab, from Dirty’s favorite kind of pizza to his struggles with fame and success, Buddha tells the real story—<i>The Dirty Version</i>—of the legendary rapper. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Buddha Monk, Mickey Hess
      </h2>
      
      <p class="authorDescription body article"><P><B>Buddha Monk is an MC, producer, and singer who toured the world with Ol&#8217; Dirty Bastard and the Wu-Tang Clan. He was Dirty&#8217;s onstage hype man and was instrumental in recording and producing his debut solo album, <I>Return to the 36 Chambers: The Dirty Version.</I> The saga continues: today Buddha tours and releases albums as a solo artist and produces and performs with acts such as the Committee, Heissman&#8212;Black Bush the Movement, Zu Bulliez, Brooklyn Zu, and many more.</B></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?823de4ba